export default "__VITE_ASSET__049842e3__"